//formats to YYYY-MM-DD using UTC to avoid timezone shifts
export const formatDate = (value: string | Date | null) => {
	if (!value) {
		return;
	}

	const date = new Date(value);
	const formattedDate = [
		date.getUTCFullYear(),
		`0${date.getUTCMonth() + 1}`.slice(-2),
		`0${date.getUTCDate()}`.slice(-2),
	].join('-');
	return formattedDate;
};

export const formatDateLocal = (value: string | Date | null) => {
	if (!value) {
		return;
	}

	if (typeof value === 'string') {
		return value.slice(0, 10);
	}

	const formattedDate = [
		value.getFullYear(),
		`0${value.getMonth() + 1}`.slice(-2),
		`0${value.getDate()}`.slice(-2),
	].join('-');
	return formattedDate;
};
